export default __webpack_public_path__ + "1b25a909bb7721e2622bffa7d41b7068.jpg";